;(function (angular, _, moment) {
  'use strict'
  angular.module('kilo.common.services')
    .service('FilterService', FilterService)

  FilterService.$inject = [
    // Angular
    '$q',

    // Libs

    // Managers
    'BpuManager', 'CategoryManager', 'CreditNoteManager', 'EntityManager', 'InvoiceManager',
    'ProductManager', 'QuoteManager', 'TagManager',
    'OrderManager', 'BalanceManager', 'ProductTypeManager'

    // Services

    // Const

    // Resolved

  ]

  function FilterService (
    // Angular
    $q,

    // Libs

    // Managers
    BpuManager, CategoryManager, CreditNoteManager, EntityManager, InvoiceManager,
    ProductManager, QuoteManager, TagManager,
    OrderManager, BalanceManager, ProductTypeManager

    // Services

    // Const

    // Resolved

  ) {
    var self = this

    _.extend(self, {
      // Public Attributes

      // Public Method
      addCriteria: addCriteria,
      groupFind: groupFind,
      hasArchivedCriteria: hasArchivedCriteria,
      getArchivedCriteria: getArchivedCriteria,
      parseQueryTree: parseQueryTree,
      sanitizeSearchTree: sanitizeSearchTree,
      searchClients: searchClients,
      searchAccounts: searchAccounts,
      searchSirets: searchSirets,
      simpleSearchClients: simpleSearchClients,
      searchBalances: searchBalances,
      searchClientsNumber: searchClientsNumber,
      searchCreditNoteTitle: searchCreditNoteTitle,
      searchCreditNoteRef: searchCreditNoteRef,
      searchCustomFieldText: searchCustomFieldText,
      searchInvoice: searchInvoice,
      searchInvoiceRef: searchInvoiceRef,
      searchInvoiceTitle: searchInvoiceTitle,
      searchOrderTitle: searchOrderTitle,
      searchOrderRef: searchOrderRef,
      searchProductLabel: searchProductLabel,
      searchProductRef: searchProductRef,
      searchProductCategories: searchProductCategories,
      searchQuoteRef: searchQuoteRef,
      searchQuoteTitle: searchQuoteTitle,
      searchTags: searchTags,
      searchBpuLabel: searchBpuLabel,
      searchBpu: searchBpu,
      searchTypes: searchTypes,
      searchUsableProductCategories: searchUsableProductCategories
    })

    // BASE MECANISM

    function addCriteria (search, key, criteria, negation) {
      if (criteria === undefined || criteria === null) {
        return search
      }

      function testEquality (e1, e2) {
        if (!_.isUndefined(e1._id) && !_.isUndefined(e2._id)) {
          return e1._id === e2._id
        }
        if (!_.isUndefined(e1.value) && !_.isUndefined(e2.value)) {
          return e1.value === e2.value
        }
        return e1 === e2
      }

      var ob = {key: key, criteria: criteria, __NOT: negation}
      if (_.isEmpty(search)) {
        search = ob
      } else {
        var path = '__AND'
        /*
         * The search object should contain a __AND close first as root, but the user might change it
         * Create the root __AND if needed, and move the current object inside this clause
         */
        if (!_.get(search, path)) {
          search = {__AND: [search]}
          // search.__AND.push({key: key, criteria: criteria})
        }

        /* Below is the code used to attach the criteria to existing criterias in the search

        Using the following rule:
         If a criteria already exists at the root of the path with the same key, wrap both in an "__OR" clause
         because there would be no point in searching two criterias mutually exclusive.
         If such a __OR clause already exists (with only criterias on the same key), add the criteria to this clause
         If more than one such clause exist, just add the criteria in the global path object,
         since it doesn't really make sense anymore, let the user be.

        /** If another element with the same key already exists, add both elements in a __OR clause
         *  If more than one exist, keep adding to the __AND clause
         */
        var alreadyPresent = _.get(search, path).filter(function (elt) { return elt.key === key })
        /** Find if some __OR clause exist with only operands of the same key  */
        var alreadyOrClause = _.get(search, path).filter(function (elt) {
          return elt.__OR && _.every(elt.__OR, function (cond) { return cond.key === key })
        })
        if (alreadyPresent.length === 1) {
          var present = alreadyPresent[0]
          // Remove relevant elements from the parent clause
          _.set(search, path, _.get(search, path).filter(function (elt) { return elt.key !== key }))
          if (testEquality(present.criteria, ob.criteria)) {
            _.get(search, path).push(ob)
          } else {
            alreadyPresent.push(ob)
            _.get(search, path).push({__OR: alreadyPresent})
          }
        } else if (alreadyOrClause.length === 1) {
          var or = alreadyOrClause[0].__OR
          var found = _.find(or, function (elt) {
            return testEquality(elt.criteria, ob.criteria)
          })
          if (found) {
            _.remove(or, function (elt) {
              return testEquality(elt.criteria, ob.criteria)
            })
          }
          alreadyOrClause[0].__OR.push(ob)
        } else {
          _.remove(_.get(search, path), function (elt) { return elt.criteria && testEquality(elt.criteria, ob.criteria) })
          _.get(search, path).push(ob)
        }
      }
      return search
    }

    /* escape all the reserved chars in a regex. Allow to send it as a mongodb regex query */
    function escapeRegex (reg) {
      return reg.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
    }

    /**
     * Given a query tree, format it to the simplest correct form.
     * Handles removing useless operators, trimming,
     * and updating from legacy search objects.
     * @param {Object} tree
     */
    function sanitizeSearchTree (tree) {
      if (!tree) return {}
      var keys = _.filter(_.keys(tree), function (k) { return k.substr(0, 2) !== '$$' })
      var logic = findLogic(tree)
      if (logic) {
        /** If the node is a logic one, only an operator is allowed. Remove the others */
        if (keys.length > 1) {
          keys.forEach(function (k, index) {
            if (index > 0) delete tree[k]
          })
        }
        if (!Array.isArray(tree[logic])) tree[logic] = []
        var children = tree[logic].map(function (elt) { return sanitizeSearchTree(elt) })

        /** If we are a logic operator with only one child, we are useless. Return the child instead */
        if (children.length === 1) {
          Object.keys(tree).forEach(function (k) { delete tree[k] })
          Object.keys(children[0]).forEach(function (k) { tree[k] = children[0][k] })
          tree = children[0]
          return tree
        }

        var newChildren = []
        // If our logic operator contains clauses of the same logic operator, get them up at the same level.
        children.forEach(function (child) {
          if (!child[logic]) {
            newChildren.push(child)
          } else if (Array.isArray(child[logic])) {
            newChildren = newChildren.concat(child[logic])
          }
        })
        tree[logic] = newChildren
        if (!tree[logic].length) delete tree[logic]
      } else if (!_.isEmpty(tree)) {
        // Handle momentJS not liking being serialized
        if (tree.key === 'interval' && tree.criteria !== undefined && tree.criteria !== null ) {
          var i = tree.criteria
          var start = i.start._d ? i.start._d : i.start
          var end = i.end._d ? i.end._d : i.end
          tree.criteria = moment.range(start, end)
        }
        // Smooth transition from legacy search system to the new one
        // If the object doesn't contain criteria and key, it is an old one and must be replaced
        if (tree.criteria === undefined || tree.criteria === null || !tree.key) {
          // Some queries just need their key translated
          var oldKeysToNew = {
            occupants: 'tenant',
            customersOrders: 'billingEntity',
            customers: 'billingEntity',
            searchPlain: 'title',
            tag: 'tags',
            owners: 'owner'
          }
          var newArray = keys.map(function (k) {
            var entries
            if (k === 'dynamicDate' || k === 'interval') return
            // Handle special cases transitionning from old to new search
            var entryToCriteria = function (entry) {
              switch (k) {
              }
              // default case, just copy the entry in criteria
              return {key: oldKeysToNew[k] || k, criteria: entry}
            }
            if (Array.isArray(tree[k])) {
              var mappedEntries = _.compact(tree[k].map(entryToCriteria))
              if (mappedEntries.length) entries = {__OR: mappedEntries}
            } else {
              entries = entryToCriteria(tree[k])
            }
            return entries
          })
          newArray = _.compact(newArray)
          if (newArray.length) {
            tree = sanitizeSearchTree({__AND: newArray})
          } else tree = null
        }
      }
      return tree
    }

    function searchBalances (search) {
      if (!search) return $q.resolve([])
      const values = search === 'positive' ? { $gte: 0 } : { $lt: 0 }
      var q = BalanceManager.query({
        conditions: {
          'value': values
        }
      })
        .fields('_id value client')
      return BalanceManager.get(q)
        .then(function (data) {
          var limitedData = data.data.map((elt) => { return elt.client })
          return limitedData
        })
    }

    /**
     * Given a criteria, returns the corresponding query suited for mongoDB
     * @param {Object} tree
     */
    function formatCriteria (tree) {
      if (!tree.key || tree.criteria === undefined || tree.criteria === null) { return }
      var criteria = tree.criteria
      var key = tree.key
      var negation = tree.__NOT
      var newObj = {}
      switch (key) {
        case '_id':
          if (negation) {
            newObj['_id'] = { $nin: criteria.value }
          } else {
            newObj['_id'] = { $in: criteria.value }
          }
          break
        case 'isArchived':
          if (criteria.value !== 'both') {
            newObj['isArchived'] = criteria.value
          } else {
            return
          }
          break
        case 'status':
          if (negation) {
            newObj['status'] = {$ne: criteria.status}
          } else {
            newObj['status'] = criteria.status
          }
          break
        case 'invoiceDeposit':
          if(tree.criteria.v) {
            newObj['invoiceDeposit.0'] = { $exists: true }
          } else {
            newObj['invoiceDeposit.0'] = { $exists: false }
          }
          break
        case 'date':
          newObj = dateQueryInvoiceFromInterval(criteria, negation)
          break
        case 'signDate' :
          newObj = signDateQueryInvoiceFromInterval(criteria, negation)
          break
        case 'payment':
          if (negation) {
            newObj['payments.type'] = { $ne: criteria.value }
          } else {
            newObj['payments.type'] = criteria.value
          }
          break
        case 'dateDynamic':
          var value = criteria[0] ? criteria[0].value : criteria.value
          var interval = dynamicDate(value)
          newObj = dateQueryInvoiceFromInterval(interval, negation)
          break
        case 'dueDate':
          newObj = dueDateQueryInvoiceFromInterval(criteria, negation)
          break
        case 'createdAt':
          newObj = createdAtQueryInvoiceFromInterval(criteria, negation)
          break
        case 'createdAtDateDynamic':
          const valu = criteria[0] ? criteria[0].value : criteria.value
          const inter = dynamicDate(valu)
          newObj = createdAtQueryInvoiceFromInterval(inter, negation)
          break
        case 'dueDateDynamic':
          var value = criteria[0] ? criteria[0].value : criteria.value
          var interval = dynamicDate(value)
          newObj = dueDateQueryInvoiceFromInterval(interval, negation)
          break
        case 'totalMax':
          newObj['total'] = {
            $lte: criteria
          }
          break
        case 'fullTotalMax':
          newObj['fullTotal'] = {
            $lte: criteria
          }
          break
        case 'discountMin':
          newObj['computed.discount'] = {
            $gte: criteria
          }
          break
        case 'discountMax':
          newObj['computed.discount'] = {
            $lte: criteria
          }
          break
        case 'discountedTotalHtMin':
          newObj['computed.fullDiscountedTotal'] = {
            $gte: criteria
          }
          break
        case 'discountedTotalHtMax':
          newObj['computed.fullDiscountedTotal'] = {
            $lte: criteria
          }
          break
        case 'totalMin':
          newObj['total'] = {
            $gte: criteria
          }
          break
        case 'fullTotalMin':
          newObj['fullTotal'] = {
            $gte: criteria
          }
          break
        case 'integratedOnChorus':
          newObj['chorusFields.integratedOnChorus'] = negation ? { $exists: false } : true
          break
        case 'chorusStatutCourant':
          newObj['chorusFields.statutCourant'] = negation ? { $ne: criteria.value } : criteria.value
          break
        case 'priceMax':
          newObj['price.amount'] = {
            $lte: criteria
          }
          break
        case 'priceMin':
          newObj['price.amount'] = {
            $gte: criteria
          }
          break
        case 'interventionsCount':
          if (negation) {
            if(criteria === 0) {
              newObj['linkedData.solica.interventions.0'] = {
                $exists: true
              }
            } else {
              newObj['linkedData.solica.interventions'] = {
                $not: {
                  $size: criteria
                }
              }
            }
          }
          else {
            newObj['linkedData.solica.interventions'] = {
              $size: criteria
            }
          }
          break
        case 'label':
          if (negation) {
            if (criteria.origin === 'precise' || criteria.origin === 'simple') {
              newObj[key] = { $ne: _.get(criteria.v, 'label', criteria.v) }
            } else {
              newObj[key] = { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' }
            }
          } else {
            if (criteria.origin === 'precise' || criteria.origin === 'simple') {
              newObj[key] = _.get(criteria.v, 'label', criteria.v)
            } else {
              newObj[key] = { $regex: escapeRegex(criteria.v), $options: 'i' }
            }
          }
          break
        case 'title':
        case 'reference':
        case 'ref':
          if (negation) {
            if (criteria.origin === 'precise')
              newObj[key] = { $ne: criteria.v}
            else
              newObj[key] = { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' }
          } else {
            if (criteria.origin === 'precise')
              newObj[key] = criteria.v
            else
              newObj[key] = { $regex: escapeRegex(criteria.v), $options: 'i' }
          }
          break
        case 'delivery':
          if (criteria.origin === 'asIs') {
            newObj.deliveries = negation
              ? {
                'flags': { $ne: 'provider' },
                $and: [
                  { '__t': { $in: ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing', 'Contact'] } },
                  { $or: [
                    { 'insensitive': { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' } },
                    { 'address.fullAddress': { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' } }
                  ] }
                ]
              }
              : {
                'flags': { $ne: 'provider' },
                $and: [
                  { '__t': { $in: ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing', 'Contact'] } },
                  { $or: [
                    { 'insensitive': { $regex: escapeRegex(criteria.v), $options: 'i' } },
                    { 'address.fullAddress': { $regex: escapeRegex(criteria.v), $options: 'i' } }
                  ] }
                ]
              }
          } else {
            var val = criteria
            if (criteria._id) val = criteria._id
            else if (_.get(criteria, 'value._id')) val = criteria.value._id
            newObj[key] = negation ? { $ne: val } : val
          }
          break
        case 'client':
          if (criteria.origin === 'asIs') {
            newObj.entities = negation
              ? {
                'flags': { $ne: 'provider' },
                $and: [
                  { '__t': { $in: ['Organization', 'Agency', 'Contact'] } },
                  { $or: [
                    { 'insensitive': { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' } },
                    { 'number': { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' } },
                    { 'address.fullAddress': { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' } }

                  ] }
                ]
              }
              : {
                'flags': { $ne: 'provider' },
                $and: [
                  { '__t': { $in: ['Organization', 'Agency', 'Contact'] } },
                  { $or: [
                    { 'insensitive': { $regex: escapeRegex(criteria.v), $options: 'i' } },
                    { 'number': { $regex: escapeRegex(criteria.v), $options: 'i' } },
                    { 'address.fullAddress': { $regex: escapeRegex(criteria.v), $options: 'i' } }
                  ] }
                ]
              }
          } else {
            var val = criteria
            if (criteria._id) val = criteria._id
            else if (_.get(criteria, 'value._id')) val = criteria.value._id
            newObj[key] = negation ? { $ne: val } : val
          }
          break
        case 'cancelByUser':
          newObj[key] = negation ? !criteria.value : criteria.value
          break
        case 'invoiceNumber':
        case 'quoteNumber':
        case 'creditNoteNumber':
          newObj['number'] = negation ? { $ne: parseInt(criteria) } : parseInt(criteria)
          break
        default:
          // newObj[key] = negation ? {$not: {$eq: criteria.v}} : criteria.v
          var customFieldTypes = ['number', 'string', 'boolean']
          if (_.includes(customFieldTypes, typeof criteria.v)) {
            switch (typeof criteria.v) {
              case 'string':
                if (_.get(criteria, 'origin') === 'asIs') {
                  if (negation) {
                    // MongoDB doesn't accept $not with regexes. Use a negative lookahead (?!) to negate the regex instead.
                    // This might be approxomative and or CPU intensive. To be tested
                    newObj['$or'] = [
                      { key: { $regex: '^(?!.*' + escapeRegex(criteria.v) + ')', $options: 'i' } },
                      { key: { $exists: false } }
                    ]
                  } else {
                    newObj[key] = { $regex: escapeRegex(criteria.v), $options: 'i' }
                  }
                  break
                }
              default:
                if (negation) {
                  newObj[key] = { $ne: criteria.v }
                } else {
                  newObj[key] = criteria.v
                }
            }

          } else if (_.get(criteria, 'v.start') && _.get(criteria, 'v.end') && key !== 'bpu') {
            newObj = customDateQueryFromInterval(key, criteria.v, negation)
          } else if (criteria.start && criteria.end && key !== 'bpu') {
            newObj = customDateQueryFromInterval(criteria, key, negation)
          } else {
            var val = criteria
            if (criteria._id) val = criteria._id
            else if (_.get(criteria, 'value._id')) val = criteria.value._id
            newObj[key] = negation ? { $ne: val } : val
          }
      }
      return newObj
    }

    function findLogic (tree) {
      var logicOperators = ['__OR', '__AND']
      return logicOperators.find(function (op) { return !!tree[op] })
    }

    /**
     * Takes a query object (as used for display in UI) and makes it a mongodb query Object
     * This method is called before making any query, but the result is not saved.
     * It is for querying only.
     * @param {Object} tree - The full query object
     * @returns {Object} query - The formatted Query, ready to be passed to baucis 'conditions'
     */
    function parseQueryTree (tree) {
      var newObj
      var logicKeywords = ['__AND', '__OR']
      var logic = findLogic(tree)
      if (logic) {
        newObj = {}
        // Do not use $ to avoid conflict with angular internals
        var key = logic.replace('__', '$').toLowerCase()
        if (Array.isArray(tree[logic])) {
          var arr = _.compact(tree[logic].map(function (v) { return parseQueryTree(v) }))
          if (arr.length) newObj[key] = arr
        } else {
          newObj[key] = parseQueryTree(tree[logic])
        }
      } else {
        newObj = formatCriteria(tree)
      }
      return newObj
    }

    /*
* Given a search object, searches if a criteria "isArchived" is present
* returns Boolean
*/
    function hasArchivedCriteria (tree, isTruthy) {
      var logic = findLogic(tree)
      if (logic) {
        var trees = tree[logic]
        return _.reduce(trees, function (acc, elt) {
          if (elt.key === 'isArchived') {
            return elt.criteria.value
          }
          return acc || hasArchivedCriteria(elt)
        }, false)
      } else {
        if (isTruthy) {
          return (_.get(tree, 'key') === 'isArchived' && tree.criteria.value)
        } else {
          return _.get(tree, 'key') === 'isArchived'
        }
      }
    }

    function getArchivedCriteria (tree) {
      var logic = findLogic(tree)
      if (logic) {
        var trees = tree[logic]
        return _.reduce(trees, function (acc, elt) {
          return acc || getArchivedCriteria(elt)
        }, false)
      } else {
        return _.get(tree, 'criteria.value')
      }
    }

    function groupFind (item) {
      if (item) {
        switch (item.origin) {
          case 'precise':
          case 'address':
            return 'Résultats :'
          case 'simple':
            return 'Résultats en rapport :'
          case 'asIs':
            return 'Effectuer la recherche telle quelle'
          case 'addressAsIs':
            return 'Effectuer la recherche telle quelle'
          case 'city':
            return 'Rechercher la ville'
          case 'shippingEntity':
            return 'Référence'
        }
      }
    }

    /**
     * Generates a momentjs interval from a dynamic date string
     * @param {('yesterday'|'today'|'tomorrow'|'week'|'nextWeek'|'previousMonth'|'currentMonth'|'3month'|'lastWeek')} date - the string describing the date to be generated
     * @returns {Object} interval
     * @returns {moment} interval.start
     * @returns {moment} interval.end
     */
    function dynamicDate (date) {
      // Fix dynamicDate deletion
      switch (date) {
        case 'yesterday':
          return {
            start: moment().subtract(1, 'day').startOf('day'),
            end: moment().subtract(1, 'day').endOf('day')
          }
        case 'today':
          return {
            start: moment().startOf('day'),
            end: moment().endOf('day')
          }
        case 'tomorrow':
          return {
            start: moment().add(1, 'day'),
            end: moment().add(1, 'day')
          }
        case 'week':
          return {
            start: moment().startOf('week'),
            end: moment().endOf('week')
          }
        case 'nextWeek':
          return {
            start: moment().startOf('week').add(1, 'week'),
            end: moment().endOf('week').add(1, 'week')
          }
        case 'previousMonth':
          return {
            start: moment().subtract(1, 'month').startOf('month').startOf('day'),
            end: moment().subtract(1, 'month').endOf('month').endOf('day')
          }
        case 'currentMonth':
          return {
            start: moment().startOf('month').startOf('day'),
            end: moment().endOf('month').endOf('day')
          }
        case '3month':
          return {
            start: moment().startOf('month').add(3, 'month').startOf('month'),
            end: moment().endOf('month').add(3, 'month').endOf('month')
          }
        case 'lastWeek':
          return {
            start: moment().startOf('week').subtract(1, 'week').startOf('day'),
            end: moment().endOf('week').subtract(1, 'week').endOf('day')
          }
        default:
          var error = { 'message': "Dynamic date option isn't supported", 'configuration': date }
          throw error
      }
    }

    // COMMON SEARCH

    function simpleSearchClients(search, select) {
      var query = EntityManager
      .query({
        conditions: {
          'flags': {$ne: 'provider'},
          $or: [
            {
              'insensitive': {
                $regex: search.toLowerCase(),
                $options: 'i'
              }
            },
            {
              'number': {
                $regex: search.toLowerCase(),
                $options: 'i'
              }
            }
          ]
        }
      })
      .fields('_id label number')
      .limit(10)
      if (select) {
        query.select(select, '__t')
      }
      return EntityManager.get(query)
      .then(function (data) {
        return data.data
      })
    }

    function searchClients (search, select) {
      if (!search) return $q.resolve([])
      var q = EntityManager.query({
        conditions: {
          'flags': { $ne: 'provider' },
          'insensitive': {
            $regex: search.toLowerCase(),
            $options: 'i'
          }
        }
      })
        .fields('_id label')
        .paginate({ limit: 20 })
      if (select) {
        q.select(select, '__t')
      }
      return EntityManager.get(q)
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: search.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function searchClientsNumber (search, select) {
      if (!search) return $q.resolve([])
      var q = EntityManager.query({
        conditions: {
          'flags': { $ne: 'provider' },
          'number': {
            $regex: search.toLowerCase(),
            $options: 'i'
          }
        }
      })
        .fields('_id number')
        .paginate({ limit: 20 })
      if (select) {
        q.select(select, '__t')
      }
      return EntityManager.get(q)
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{ origin: 'asIs', v: search.toUpperCase() }].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d.number
            }
          }), 'origin'))
        })
    }

    function searchAccounts (search, select) {
      if (!search) return $q.resolve([])
      var q = EntityManager.query({
        conditions: {
          'account':
            {
              $regex: search.toLowerCase(),
              $options: 'i'
            }
        }
      })
        .fields('_id account')
        .paginate({ limit: 20 })
      if (select) {
        q.select(select, '__t')
      }
      return EntityManager.get(q)
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{ origin: 'asIs', v: search.toUpperCase() }].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d.account
            }
          }), 'origin'))
        })
    }

    function searchSirets (search, select) {
      if (!search) return $q.resolve([])
      var q = EntityManager.query({
        conditions: {
          'siret':
            {
              $regex: search.toLowerCase(),
              $options: 'i'
            }
        }
      })
        .fields('_id siret')
        .paginate({ limit: 20 })
      if (select) {
        q.select(select, '__t')
      }
      return EntityManager.get(q)
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{ origin: 'asIs', v: search.toUpperCase() }].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d.siret
            }
          }), 'origin'))
        })
    }

    function searchInvoice (search) {
      var query = InvoiceManager
        .query({
          conditions: {$or: [
            {
              reference: {
                $regex: '.*' + search + '.*', $options: 'i'
              }
            },
            {
              title: {
                $regex: '.*' + search + '.*', $options: 'i'
              }
            }
          ]
        }})
        .fields('_id reference title')
        .limit(10)
      return InvoiceManager.get(query).then(function (data) {
        return data.data
      })
    }

    function searchTags (search) {
      return TagManager.get(
        TagManager
          .query()
          .search(search, 'label')
          .limit(10))
        .then(function (data) {
          return data.data
        })
    }

    function searchCustomFieldText (query, key, manager) {
      if (!query) return $q.resolve([])
      return manager.get(
        manager
        .query({sort: key, distinct: key})
        .paginate({limit: 20})
        .search(query, key)
      ).then(function (data) {
        var limitedData = _.take(data.data, 20)
        return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          }
        }), 'origin'))
      })
    }

    // INVOICE SEARCH

    /**
     * Return invoices with ref matching query
     * @param query String
     * @returns Promise = Invoice[]
     */
    function searchInvoiceRef (query) {
      if (!query) return $q.resolve([])
      return InvoiceManager.get(
        InvoiceManager.query({sort: 'reference', distinct: 'reference'})
          .paginate({limit: 20})
          .search(query, 'reference'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    /**
     * Return invoices with title matching query
     * @param query String
     * @returns Promise = Invoice[]
     */
    function searchInvoiceTitle (query) {
      if (!query) return $q.resolve([])
      return InvoiceManager.get(
        InvoiceManager.query({
          sort: 'title',
          distinct: 'title',
          conditions: {
            isModel: { $exists: false }
          }
        })
          .paginate({limit: 20})
          .search(query, 'title'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function customDateQueryFromInterval (key, interval, negation) {
      if (interval.start && interval.end) {
        var customConditionArray = [{}, {}]
        var start = moment(interval.start).startOf('day').toDate()
        var end = moment(interval.end).endOf('day').toDate()
        if (negation) {
          customConditionArray[0][key] = {$lte: start}
          customConditionArray[1][key] = {$gte: end}
          return {
            $or: customConditionArray
          }
        }
        customConditionArray[0][key] = {$lte: end}
        customConditionArray[1][key] = {$gte: start}
        return {
          $and: customConditionArray
        }
      }
    }

    function signDateQueryInvoiceFromInterval (interval, negation) {
      if (interval.start && interval.end) {
        var start = moment(interval.start).startOf('day').toDate()
        var end = moment(interval.end).endOf('day').toDate()
        if (negation) {
          return {
            $or: [
              {
                signDate: {
                  $lte: start
                }
              },
              {
                signDate: {
                  $gte: end
                }
              }
            ]
          }
        }
        return {
          $and: [
            {
              signDate: {
                $lte: end
              }
            },
            {
              signDate: {
                $gte: start
              }
            }
          ]
        }
      }
    }
    function dateQueryInvoiceFromInterval (interval, negation) {
      if (interval.start && interval.end) {
        var start = moment(interval.start).startOf('day').toDate()
        var end = moment(interval.end).endOf('day').toDate()
        if (negation) {
          return {
            $or: [
              {
                date: {
                  $lte: start
                }
              },
              {
                date: {
                  $gte: end
                }
              }
            ]
          }
        }
        return {
          $and: [
            {
              date: {
                $lte: end
              }
            },
            {
              date: {
                $gte: start
              }
            }
          ]
        }
      }
    }

    function dueDateQueryInvoiceFromInterval (interval, negation) {
      if (interval.start && interval.end) {
        var start = moment(interval.start).startOf('day').toDate()
        var end = moment(interval.end).endOf('day').toDate()
        if (negation) {
          return {
            $or: [
              {
                dueDate: {
                  $lte: start
                }
              },
              {
                dueDate: {
                  $gte: end
                }
              }
            ]
          }
        }
        return {
          $and: [
            {
              dueDate: {
                $lte: end
              }
            },
            {
              dueDate: {
                $gte: start
              }
            }
          ]
        }
      }
    }

    function createdAtQueryInvoiceFromInterval (interval, negation) {
      if (interval.start && interval.end) {
        const start = moment(interval.start).startOf('day').toDate()
        const end = moment(interval.end).endOf('day').toDate()
        if (negation) {
          return {
            $or: [
              {
                createdAt: {
                  $lte: start
                }
              },
              {
                createdAt: {
                  $gte: end
                }
              }
            ]
          }
        }
        return {
          $and: [
            {
              createdAt: {
                $lte: end
              }
            },
            {
              createdAt: {
                $gte: start
              }
            }
          ]
        }
      }
    }

    // CREDIT NOTE SEARCH

    /**
     * Return invoices with title matching query
     * @param query String
     * @returns Promise = Invoice[]
     */
    function searchCreditNoteTitle (query) {
      if (!query) return $q.resolve([])
      return CreditNoteManager.get(
        CreditNoteManager.query({sort: 'title', distinct: 'title'})
          .paginate({limit: 20})
          .search(query, 'title'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function searchCreditNoteRef (query) {
      if (!query) return $q.resolve([])
      return CreditNoteManager.get(
        CreditNoteManager.query({sort: 'reference', distinct: 'reference'})
          .paginate({limit: 20})
          .search(query, 'reference'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    // QUOTE SEARCH

    function searchQuoteTitle (query) {
      if (!query) return $q.resolve([])
      return QuoteManager.get(
        QuoteManager.query({
          conditions: {
            isModel: { $exists: false }
          },
          sort: 'title',
          distinct: 'title'
        })
          .paginate({limit: 20})
          .search(query, 'title'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function searchQuoteRef (query) {
      if (!query) return $q.resolve([])
      return QuoteManager.get(
        QuoteManager.query({sort: 'reference', distinct: 'reference'})
          .paginate({limit: 20})
          .search(query, 'reference'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    // ORDER SEARCH

    function searchOrderTitle (query) {
      if (!query) return $q.resolve([])
      return OrderManager.get(
        OrderManager.query({sort: 'title', distinct: 'title'})
          .paginate({limit: 20})
          .search(query, 'title'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function searchOrderRef (query) {
      if (!query) return $q.resolve([])
      return OrderManager.get(
        OrderManager.query({sort: 'reference', distinct: 'reference'})
          .paginate({limit: 20})
          .search(query, 'reference'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    // PRODUCT SEARCH

    function searchProductLabel (query) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(
        ProductManager.query({sort: 'label', distinct: 'label', conditions: { 'flags': 'sufa', isArchived: false, isDeleted: false }})
          .paginate({limit: 20})
          .search(query, 'label'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function searchProductRef (query) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(
        ProductManager.query({sort: 'reference', distinct: 'reference', conditions: { 'flags': 'sufa', isArchived: false, isDeleted: false }})
          .paginate({limit: 20})
          .search(query, 'reference'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function searchProductCategories (query) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(
        ProductManager.query({sort: 'category', distinct: 'category', conditions: { 'flags': 'sufa', isArchived: false, isDeleted: false }})
          .paginate({limit: 20})
          .search(query, 'category'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return _.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin')
        })
    }

    function searchUsableProductCategories (query) {
      return CategoryManager.get(
        CategoryManager.query({sort: 'label', distinct: 'label'})
          .paginate({limit: 20})
          .search(query, 'label')
      ).then(function (data) {
        return data.data
      })
    }

    // BPU SEARCH

    function searchBpuLabel (query) {
      if (!query) return $q.resolve([])
      return BpuManager.get(
        BpuManager.query({sort: 'label', distinct: 'label'})
          .paginate({limit: 20})
          .search(query, 'label'))
        .then(function (data) {
          var limitedData = _.take(data.data, 20)
          return [{origin: 'asIs', v: query.toUpperCase()}].concat(_.sortBy(limitedData.map(function (d) {
            return {
              origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
              _id: d,
              v: d
            }
          }), 'origin'))
        })
    }

    function searchBpu (search = '') {
      const query = BpuManager.query({
        populate: JSON.stringify([
          {
            path: 'client'
          }
        ]),
        limit: 10
      })
      if (search.trim().length) {
        const searchRegex = {
          $regex: search.trim(),
          $options: 'i'
        }
        query.opts.conditions = {
          $or: [
            { label: searchRegex },
            { number: searchRegex }
          ]
        }
      }

      // if (!query) return $q.resolve([])
      return BpuManager.get(query)
        .then(function (data) {
          return data.data
        })
    }

    function searchTypes (search = '') {
      const query = ProductTypeManager.query({
        limit: 10
      })
      if (search.trim().length) {
        const searchRegex = {
          $regex: search.trim(),
          $options: 'i'
        }
        query.opts.conditions = { label: searchRegex }
      }
      // if (!query) return $q.resolve([])
      return ProductTypeManager.get(query)
        .then(function (data) {
          return data.data
        })
    }
  }
})(window.angular, window._, window.moment)
